import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserCreate {
  constructor($scope, GeoService, UserService, UserContactService) {
    $scope.tabs = [
      '1. Company Details',
      '2. Personal Contact Details',
      '3. Account Type & Groups',
      '4. Product Categories & Groups'
    ];

    $scope.similarity_tabs = UserService.get_similar_tabs();

    $scope.compare_tabs = UserService.get_similar_dialog_tabs();

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.set_selected_similarity_tab = function(index) {
      $scope.selected_similarity_tab = index;
      $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
    };

    $scope.set_selected_compare_tab = function(index) {
      $scope.selected_compare_tab = index;
    };

    $scope.get_filtered_similar_users_length = function(index) {
      if (index === 0)
        return $scope.similar_users.length;
      else
        return $scope.get_filtered_similar_users(index).length;
    };

    $scope.get_filtered_similar_users = function(index) {
      return UserService.get_filtered_similar_users($scope.similar_users, index);
    };

    $scope.$watch('user.country_id', function() {
      if ($scope.user.country_id)
        $scope.user_country_name = $('#country option[value="' + $scope.user.country_id + '"]').html();
      else
        $scope.user_country_name = '';
      if ($scope.user.country_id) {
        GeoService.get_cities($scope.user.country_id).then(function(data) {
          $scope.cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.user.city_id}))
            $scope.user.city_id = null;
        });
      }
    });

    $scope.$watch('user.city_id', function() {
      if ($scope.user.city_id)
        $scope.user_city_name = $('#city option:selected').text();
      else
        $scope.user_city_name = '';
    });

    $scope.find_similar_users = function() {
      $scope.processing = true;

      var data = {
        company_title: null,
        emails: [],
        phones: [],
        faxes: [],
        vat: null,
        last_names: [],
        post_codes: []
      };

      if ($scope.user.company_title)
        data.company_title = $scope.user.company_title;
      if ($scope.user.company_email)
        data.emails.push($scope.user.company_email);
      if ($scope.account.username)
        data.emails.push($scope.account.username);
      if ($scope.user.user_contacts_attributes[0].email)
        data.emails.push($scope.user.user_contacts_attributes[0].email);
      if ($scope.user.user_contacts_attributes[0].last_name)
        data.last_names.push($scope.user.user_contacts_attributes[0].last_name);
      if ($scope.user.phone)
        data.phones.push($scope.user.phone);
      if ($scope.user.user_contacts_attributes[0].phone)
        data.phones.push($scope.user.user_contacts_attributes[0].phone);
      if ($scope.user.fax)
        data.faxes.push($scope.user.fax);
      if ($scope.user.user_contacts_attributes[0].fax)
        data.faxes.push($scope.user.user_contacts_attributes[0].fax);
      if ($scope.user.ssn)
        data.vat = $scope.user.ssn;

      UserService.find_similar(data).then(function(data) {
        $scope.similar_users = data.users;
        $scope.selected_similarity_tab = 0;
        $scope.filtered_similar_users = data.users;
        $scope.processing = false;
      });
    };

    $scope.mark_as_not_similar = function() {
      $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
      $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
      $.fancybox.close();
    };

    $scope.$watch('user.user_type', function() {
      $scope.business_types = angular.copy(window.business_types);
      $scope.user.user_business_types_attributes = [];
    });

    $scope.category_changed = function(category) {
      if (!category.checked) {
        for (var i = 0; i < category.groups.length; i++)
          category.groups[i].checked = false;
      }
    };

    $scope.group_changed = function(category, group) {
      if (group.checked && !category.checked)
        category.checked = true;
    };

    $scope.deselect_group = function(group_id) {
      var group = _.find($scope.groups, function(object) {
        return object.id == group_id;
      });
      group.checked = false;
    };

    $scope.set_user_data = function() {
      $scope.user.user_product_categories_attributes = [];
      $scope.user.user_product_groups_attributes = [];
      angular.forEach($scope.product_categories, function(category) {
        if (category.checked)
          $scope.user.user_product_categories_attributes.push({
            product_category_id: category.id
          });
        for (var i = 0; i < category.groups.length; i++) {
          if (category.groups[i].checked)
            $scope.user.user_product_groups_attributes.push({
              product_group_id: category.groups[i].id
            });
        }
      });

      $scope.user.user_business_types_attributes = [];
      angular.forEach($scope.business_types, function(business_type) {
        if (business_type.checked)
          $scope.user.user_business_types_attributes.push({
            business_type_id: business_type.id
          });
      });

      $scope.user.user_groups_attributes = [];
      angular.forEach($scope.groups, function(group) {
        if (group.checked)
          $scope.user.user_groups_attributes.push({
            group_id: group.id
          });
      });
    };

    $scope.validate_password = function() {
      var password = $scope.account.password;
      var password2 = $scope.account.retype_password;
      if (!(password || password2) || password.length === 0 || (password != password2)) {
        $scope.form_error = 'Account Data - Password empty or password mismatch!';
        return false;
      }
      $scope.form_error = '';
      return true;
    };

    $scope.get_new_user = function() {
      return {
        user_type: 'Buyer',
        company_title: null,
        company_email: null,
        country_id: null,
        city_id: null,
        phone: null,
        fax: null,
        ssn: null,
        business_relation: 0,
        last_name: '',
        market: 'global',
        user_contacts_attributes: [{
          department_id: null,
          email: null,
          first_name: null,
          last_name: null,
          gender: 0,
          position: null,
          phone: null,
          fax: null,
          newsletter_settings: null,
          matching_settings: null,
          frontend_settings: null,
          welcome_email_date: null
        }],
        user_groups_attributes: [],
        user_business_types_attributes: [],
        user_product_categories_attributes: [],
        user_product_groups_attributes: []
      };
    };

    $scope.get_new_account = function() {
      return {
        username: null,
        password: null,
        retype_password: null,
        status: 'activated'
      };
    };

    $scope.save_user = function() {
      $scope.set_user_data();
      if ($scope.user.user_product_categories_attributes.length === 0) {
        $scope.form_error = 'Please select at least one product category!';
        $scope.creating_user = false;
      } else if (!$scope.user.company_email || $scope.user.company_email.length === 0) {
        $scope.form_error = 'Please type the Corporate Email!';
        $scope.creating_user = false;
      } else {
        UserService.create($scope.user, $scope.account).then(function(data) {
          if (data.success) {
            $scope.created_user_id = data.user_id;
            $scope.create_mode = false;
            $scope.show_update = false;
            $scope.form_error = '';
          } else {
            $scope.form_error = data.message;
          }
          $scope.creating_user = false;
        });
      }
    };

    $scope.create_user = function() {
      $scope.creating_user = true;
      var username = $scope.account.username;
      if (username && username.length > 0) {
        if ($scope.validate_password()) {
          UserService.account_email_exists(username).then(function(data) {
            if (data.exists) {
              $scope.form_error = 'Account email already exists!';
              $scope.show_update = false;
            } else {
              $scope.form_error = '';
              $scope.save_user();
            }
          });
        }
      } else {
        $scope.save_user();
      }
    };

    $scope.create_new_user = function() {
      $scope.init();
    };

    $scope.compare_users = function(user) {
      $scope.compare_user = user;
      $scope.open_dialog('compare_user_dialog');
    };

    $scope.on_dialog_create_action = function() {
      $scope.deselect_group(2);
      $scope.similar_users = [];
      $.fancybox.close();
      $scope.create_user();
    };

    $scope.set_update_mode = function(value) {
      $scope.update_mode = value;
      $scope.updating_user = '';
    };

    $scope.update_field = function(value, property) {
      $scope.updating_user = true;
      var update_data = {
        id: $scope.compare_user.id
      };

      if (property == 'email')
        update_data.company_email = value;
      else if (property == 'vat')
        update_data.ssn = value;
      else if (property == 'country_id')
        update_data.country_id = value;
      else if (property == 'city_id')
        update_data.city_id = value;
      else if (property == 'phone')
        update_data.phone = value;
      else if (property == 'fax')
        update_data.fax = value;

      UserService.update(update_data, null, null).then(function(data) {
        if (data.success) {
          $scope.update_error = '';
          $scope.compare_user[property] = value;
        } else {
          $scope.update_error = data.message;
        }
        $scope.updating_user = false;
      });
    };

    $scope.add_contact_to_similar = function() {
      $scope.updating_user = true;
      var contact = $scope.user.user_contacts_attributes[0];
      contact.user_id = $scope.compare_user.id;
      contact.account = $scope.account;
      contact.account.status = 'pending';
      UserContactService.save(contact).then(function(data) {
        if (data.success) {
          $scope.update_error = 'Contact added!';
        } else {
          $scope.update_error = 'Contact: ' + data.message;
        }
        if (data.account_success) {
          $scope.update_error += ', Account added!';
        } else {
          $scope.update_error += ', Account: ' + data.account_message;
        }
        $scope.updating_user = false;
      });
    };

    $scope.update_contact = function(contact) {
      $scope.updating_user = true;
      UserContactService.update_similar_contact($scope.user.user_contacts_attributes[0], $scope.account, contact.id).then(function(data) {
        if (data.success) {
          $scope.update_error = 'Contact updated!';
        } else {
          $scope.update_error = 'Contact: ' + data.message;
        }
        if (data.account_success) {
          $scope.update_error += ', Account added!';
        } else {
          $scope.update_error += ', Account: ' + data.account_message;
        }
        $scope.updating_user = false;
      });
    };

    $scope.init = function() {
      $scope.create_mode = true;
      $scope.update_mode = false;
      $scope.selected_tab = 0;
      $scope.selected_similarity_tab = 0;
      $scope.selected_compare_tab = 0;
      $scope.similar_users = [];
      $scope.groups = angular.copy(window.groups);
      $scope.business_types = angular.copy(window.business_types);
      $scope.product_categories = angular.copy(window.product_categories);
      $scope.user = $scope.get_new_user();
      $scope.account = $scope.get_new_account();
      $scope.business_relations = window.business_relations;
    };

    $scope.init();
  }
}

UserCreate.$inject = ['$scope', 'GeoService', 'UserService', 'UserContactService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-create.ctrl.js